import { useState, useEffect } from "react";
import { fetchHistoryData } from "../services/api";

const useFetchHistoryData = (page, pageSize, floor, mac, startTime, endTime) => {
    const [history, setHistory] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        const getHistoryData = async () => {
            try {
                const { data, total } = await fetchHistoryData(page, pageSize, floor, mac, startTime, endTime);
                setHistory(data);
                setRowCount(total);
            } catch (error) {
                console.error("Error fetching history data:", error);
            } finally {
                setLoading(false);
            }
        };

        getHistoryData();
    }, [page, pageSize, floor, mac, startTime, endTime]);

    return { history, total: rowCount, loading };
};

export default useFetchHistoryData;
